import ArbitrageInquiry from './arbitrage-inquiry.vue'
export default ArbitrageInquiry
